import ReactDOM from 'react-dom';
import React from 'react';
import App from './App';

import loadTranslations from '../localeSetup';

(async () => {
  const rootElement = document.getElementById('category');
  await loadTranslations();

  if (rootElement) {
    ReactDOM.render(<App />, rootElement);
  }
})();
